import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { AgGrid } from '../../AgGrid';
import classnames from 'classnames';

// SERVICES
import { getAllCallCenterUsers } from '../../../services/callcenter.service';

const styles = theme => ({});

export const CallCenterUsersGrid = withStyles(styles)(props => {
  const [gridData, setGridData] = useState(null);

  const columnDefinitions = [
    { headerName: 'Name', field: 'name' },
    { headerName: 'E-mail', field: 'email' },
    { headerName: 'Username', field: 'userName' },
    { headerName: 'Address', field: 'address' },
    { headerName: 'City', field: 'city' },
    { headerName: 'State', field: 'state' },
    { headerName: 'Zip', field: 'zip' },
    { headerName: 'Home Phone', field: 'homePhone' },
    { headerName: 'Work Phone', field: 'workPhone' },
    { headerName: 'Cell Phone', field: 'cellPhone' },
    { headerName: 'Account Status', field: 'accountStatus', width: 150 },
    { headerName: '', field: 'createdOn', width: 150 },
    { headerName: 'ID', field: 'callCenterUserid', hide: true },
  ];

  const gridOptions = {};

  const getAllCallCenterUsersAsync = async () => {
    try {
      const data = await getAllCallCenterUsers();
      console.log('Call center users data:', data); // Temporary log to see structure
      setGridData(data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllCallCenterUsersAsync();
  }, []);

  return (
    <div className={classnames('flex-1', 'col-center-center')}>
      <AgGrid
        gridData={gridData}
        gridOptions={gridOptions}
        columnDefs={columnDefinitions}
        showCreateButton={true}
        redirectOnClick={true}
        editOnClick={false}
        handleCellClick={evt => {
          console.log('Clicked row data:', evt.data); // Temporary log to see what fields are available
          const userId = evt.data.id || evt.data.userId || evt.data.callCenterUserId;
          if (userId) {
            window.location = `${window.location.href}/${userId}`;
          } else {
            console.error('No user ID found in row data:', evt.data);
          }
        }}
      />
    </div>
  );
}); 